var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.formItem.deliveryType === "express"
        ? _c(
            "el-form-item",
            { attrs: { label: "快递公司：", prop: "expressCode" } },
            [
              _c("ChangeLogistics", {
                model: {
                  value: _vm.formItem.expressCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.formItem, "expressCode", $$v)
                  },
                  expression: "formItem.expressCode",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.formItem.deliveryType === "express"
        ? _c(
            "el-form-item",
            { attrs: { label: "快递单号：", prop: "expressNumber" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入快递单号" },
                model: {
                  value: _vm.formItem.expressNumber,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formItem,
                      "expressNumber",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formItem.expressNumber",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.formItem.deliveryType === "noNeed"
        ? _c(
            "el-form-item",
            { attrs: { label: "发货备注：" } },
            [
              _c("el-input", {
                attrs: {
                  "show-word-limit": "",
                  autosize: { minRows: 4 },
                  maxlength: "200",
                  type: "textarea",
                  placeholder: "请输入备注信息，最多可输入250字",
                },
                model: {
                  value: _vm.formItem.deliveryMark,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formItem,
                      "deliveryMark",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formItem.deliveryMark",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.formItem.deliveryType === "merchant"
        ? _c(
            "el-form-item",
            { attrs: { label: "配送人员：", prop: "deliveryCarrier" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入配送人员" },
                model: {
                  value: _vm.formItem.deliveryCarrier,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formItem,
                      "deliveryCarrier",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formItem.deliveryCarrier",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.formItem.deliveryType === "merchant"
        ? _c(
            "el-form-item",
            { attrs: { label: "手机号码：", prop: "carrierPhone" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入配送人员手机号码" },
                model: {
                  value: _vm.formItem.carrierPhone,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formItem,
                      "carrierPhone",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formItem.carrierPhone",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }